<template>
  <div class="layout">
    <Layout>
      <Header>
        <div class="header">
          <div class="header_Up">
            <div class="header_Up_Box">
              <div class="header_Up_img">
                <img :src="logoSrc" alt />
              </div>
              <div class="header_Up_ul">
                <ul>
                  <!-- 首页 -->
                  <li :class="{ cur: num == 20 }" @click="onTab(20)">
                    <router-link
                      to="/home/index"
                      style="color: #494949;width:100%；height:100%;display: block;"
                      >{{ $t("system.home") }}</router-link
                    >
                  </li>
                  <li
                    v-for="(item, index) in data"
                    :class="{ cur: index == num }"
                    @click="onTab(index)"
                    :key="index"
                  >
                    <span v-if="param == 0">{{ item.Name }}</span>
                    <span v-if="param == 1">{{ item.NameEn }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="user currentVersionNumberCss">
              <Row>
                <Col span="9">
                  <ButtonGroup size="small"> </ButtonGroup>
                </Col>
                <Col span="14">
                  <template>
                    <Dropdown class="user_Style">
                      <a href="javascript:void(0)">
                        {{ this.name }}({{ this.account }})
                        <Icon type="arrow-down-b"></Icon>
                      </a>
                      <DropdownMenu slot="list">
                        <DropdownItem style="padding-left: 32px">
                          <div v-on:click="updatePassword">{{ $t("main.updatePassword") }}</div>
                        </DropdownItem>
                        <DropdownItem style="padding-left: 32px">
                          <!-- 退出系统 -->
                          <div v-on:click="onExitSystem">{{ $t("main.mainExitSystem") }}</div>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </template>
                </Col>
              </Row>
            </div>
          </div>
          <div class="header_Down_Box" v-if="isShow">
            <div
              v-for="(itemCon, index) in data"
              class="header_Down"
              v-show="index == num"
              v-bind:key=index
            >
              <ul>
                <li v-for="TwoItemCon in itemCon.ChildrenModules"  v-bind:key="TwoItemCon.ID">
                  <router-link
                    :to="TwoItemCon.Route == null ? '' : TwoItemCon.Route"
                  >
                    <span v-if="param == 0">{{ TwoItemCon.Name }}</span>
                    <span v-if="param == 1">{{ TwoItemCon.NameEn }}</span>
                  </router-link>
                  <dl class="nav">
                    <dt v-for="threeitem in TwoItemCon.ChildrenModules" v-bind:key="threeitem.ID">
                      <router-link :to="threeitem.Route">
                        <span v-if="param == 0">{{ threeitem.Name }}</span>
                        <span v-if="param == 1">{{ threeitem.NameEn }}</span>
                      </router-link>
                    </dt>
                  </dl>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="header_Down_Border" v-if="!isShow"></div>
      </Header>
      <Content class="ivu-row-Bottom-30">
        <div>
          <router-view :key="activeDate"></router-view>
        </div>
      </Content>
    <Modal
      v-model="showUpdatePasswordModal"
      :transfer="true"
      :mask-closable="false"
      width="500"
      @on-cancel="handleCancelUpdatePassword"
      :title="$t('userlist.updatePassword')"
    >
    <div class="ivu-row-Padding" style="height: 250px;">
      <Form :label-width="90"
      ref="updatePasswordForm"
      :model="employeeModel"
      :rules="ruleValidate">
        <Row>
          <Col span="24">
            <Form-item :label="$t('userlist.oldPassword')"  prop="OldPassword">
              <i-input type="password" v-model="employeeModel.OldPassword" clearable></i-input>
            </Form-item>
          </Col>
          <Col span="24">
            <Form-item :label="$t('userlist.newPassword')"  prop="NewPassword">
              <i-input type="password" v-model="employeeModel.NewPassword" clearable></i-input>
            </Form-item>
          </Col>
          <Col span="24">
            <Form-item :label="$t('userlist.pwdLevel')"  >
            <div class="input_span">
                  <span ref="refOne" class="one"></span>
                  <span  ref="refTwo" class="two"></span>
                  <span  ref="refThree" class="three"></span>
            </div>
            <div id="font">
                  <span>弱</span>
                  <span>中</span>
                  <span>强</span>
              </div>
            </Form-item>
          </Col>
          <Col span="24">
            <Form-item :label="$t('userlist.confirmPassword')"  prop="ConfirmPassword">
              <i-input type="password" v-model="employeeModel.ConfirmPassword" clearable></i-input>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
      <div slot="footer">
        <Row  >
        <Col span="24">
          <Row type="flex" justify="end" :gutter="10">
            <Col span="2.5">
              <Button
               :disabled="!(this.pwdLevel>=3)"
                @click="handleUpdatePassword()"
                icon="ios-checkmark-outline"
                >{{ $t("system.save") }}</Button
              >
            </Col>
            <Col span="2.5">
              <Button
                @click="handleCancelUpdatePassword()"
                icon="ios-close-outline"
                style="margin-left: 8px"
                >{{ $t("system.cancel") }}</Button
              >
            </Col>
          </Row>
        </Col>
      </Row>
      </div>
    </Modal>
  </Layout>
  </div>
</template>
<script>
    import moment from 'moment';
    import logo_Prod from '../assets/cdms_logo.png';
    import logo_Test from '../assets/cdms_logo_test.png';
    export default {
        data () {
            const validatePassword = (rule, value, callback) => {
                if (value !== this.employeeModel.NewPassword) {
                    callback(new Error(this.$t('userEdit.validPasswordCompare')))
                } else {
                    callback()
                }
            }
            return {
                languages: [
                    {
                        value: 'mergeZH',
                        label: '中'
                    },
                    {
                        value: 'mergeEN',
                        label: 'EN'
                    }
                ],
                account: '', // 登录账号
                name: '', // 登录人
                param: 0, // 语言切换条件
                activeDate: null, // 刷新路由
                num: 20,
                isShow: false,
                data: [],
                modalEditionShow: false,
                modalEditionList: [],
                filter: {
                    Page: 1,
                    Per: 3
                },
                // 总行数
                totalCount: 0,
                currentVersionNumber: '',
                logoSrc: logo_Test,
                employeeModel: {},
                showUpdatePasswordModal: false,
                pwdLevel: 0,
                ruleValidate: {
                    OldPassword: [
                        {
                            required: true,
                            type: 'string',
                            message: this.$t('userEdit.validOldPassword'),
                            trigger: 'blur,change'
                        }
                    ],
                    NewPassword: [
                        {
                            required: true,
                            type: 'string',
                            message: this.$t('userEdit.validNewPassword'),
                            trigger: 'blur,change'
                        }
                    ],
                    ConfirmPassword: [
                        {
                            required: true,
                            type: 'string',
                            message: this.$t('userEdit.validConfirmPassword'),
                            trigger: 'blur,change'
                        },
                        {validator: validatePassword}
                    ]
                }
            };
        },

        created () {
            // set logo
            this.getLogo();
            // 初始化语言
            this.initLanguage();
            // 语言切换
            this.languageSwitch();
            this.account = localStorage.getItem('account');
            this.name = localStorage.getItem('name');
            // 导航栏样式记录-切换
            if (sessionStorage.sessionStorageNum == null) {
                sessionStorage.sessionStorageNum = 20;
            } else {
                this.num = sessionStorage.sessionStorageNum;
            }

            if (sessionStorage.getItem('sessionStorageNum') == 20) {
                this.isShow = false;
            } else {
                this.isShow = true;
            }
            this.initModule();
        },
        methods: {
            getLogo () {
                if (
                    // TODO
                    window.location.href.indexOf('cdms.sperogenix.com:') >= 0 || window.location.href.indexOf('cdms.sperogenix.com') === -1
                ) { this.logoSrc = logo_Test; } else this.logoSrc = logo_Prod;
            },
            initModule () {
                this.data = JSON.parse(localStorage.ModulesData);
            },
            // 初始化语言
            initLanguage () {
                this.$i18n.locale =
                    localStorage.getItem('currentLanguage') === null
                        ? 'mergeZH'
                        : localStorage.getItem('currentLanguage');
            },
            changePage (value) {
                this.filter.Page = value;
            },
            changePageSize (value) {
                this.filter.Per = value;
                this.filter.Page = 1;
            },
            onChangeLanguage (value) {
                if (value === undefined) return;
                this.$i18n.locale = value;
                localStorage.setItem('currentLanguage', value);
                // 刷新路由
                this.activeDate = new Date().toLocaleTimeString();
                this.languageSwitch(); // 语言切换
            },
            // 语言切换
            languageSwitch () {
                if (
                    this.$t('system.language') === '中' ||
                    this.$t('system.language') === 'mergeZH'
                ) {
                    this.param = 0;
                } else if (
                    this.$t('system.language') === 'EN' ||
                    this.$t('system.language') === 'mergeEN'
                ) {
                    this.param = 1;
                }
            },
            onLanguage () {
                if (this.$t('system.language') === '中') {
                    this.onChangeLanguage('mergeEN');
                } else if (this.$t('system.language') === 'EN') {
                    this.onChangeLanguage('mergeZH');
                }
            },
            // tab图片切换
            onTab (index) {
                this.num = index;
                if (this.num === 20) {
                    this.isShow = false;
                } else {
                    this.isShow = true;
                }
                sessionStorage.setItem('sessionStorageNum', index);
            },
            updatePassword () {
                this.showUpdatePasswordModal = true
            },
            // 退出系统
            onExitSystem () {
                this.$http
                    .post('/User/Logout', {
                        Account: localStorage.account
                    })
                    .then((response) => {
                        localStorage.clear();
                        sessionStorage.clear();
                        this.logout();
                });
            },
            logout () {
                window.location.href = window.location.protocol + '//' + window.location.host + '/#/login';
            },
            handleCancelUpdatePassword () {
                this.showUpdatePasswordModal = false;
                this.pwdLevel = 0;
                this.$refs.updatePasswordForm.resetFields()
            },
            handleUpdatePassword () {
                this.$refs['updatePasswordForm'].validate((valid) => {
                    if (valid) {
                        this.employeeModel.LoginName = this.account
                        this.$http.post('/Employee/UpdatePassword', this.employeeModel).then(response => {
                            if (response.data.Message) {
                                this.$alert(response.data.Message, this.$t('system.alter'), {
                                    dangerouslyUseHTMLString: true
                                });
                            } else {
                                this.$Message.success(this.$t('system.saveSuccess'));
                                this.onExitSystem()
                            }
                        })
                    }
                })
            },
            checkStrong (sValue) {
                var modes = 0;
                // 正则表达式验证符合要求的
                if (sValue.length < 1) return modes;
                if (/\d/.test(sValue)) modes++; // 数字
                if (/[a-z]/.test(sValue)) modes++; // 小写
                if (/[A-Z]/.test(sValue)) modes++; // 大写
                if (/\W/.test(sValue)) modes++; // 特殊字符

                // 逻辑处理
                switch (modes) {
                case 1:
                    return 1;
                case 2:
                    return 2;
                case 3:
                    return sValue.length < 8 ? 2 : 3;
                case 4:
                    return sValue.length < 8 ? 2 : 4;
                }
                return modes;
            }
        },
        watch: {
            'employeeModel.NewPassword': {
                handler (newname, oldname) {
                    if (newname === null || newname === undefined) {
                        this.$refs.refOne.style.background = '#eee';
                        this.$refs.refTwo.style.background = '#eee';
                        this.$refs.refThree.style.background = '#eee';
                    } else {
                        this.pwdLevel = this.checkStrong(newname);
                        if (this.pwdLevel > 1 || this.pwdLevel === 1) {
                            this.$refs.refOne.style.background = 'red'
                        } else {
                            this.$refs.refOne.style.background = '#eee'
                        }
                        if (this.pwdLevel > 2 || this.pwdLevel === 2) {
                            this.$refs.refTwo.style.background = 'red';
                        } else {
                            this.$refs.refTwo.style.background = '#eee';
                        }
                        if (this.pwdLevel > 3 || this.pwdLevel === 3) {
                            this.$refs.refTwo.style.background = 'orange';
                        } else {
                            this.$refs.refTwo.style.background = '#eee';
                        }
                        if (this.pwdLevel === 4) {
                            this.$refs.refThree.style.background = '#00D1B2';
                        } else {
                            this.$refs.refThree.style.background = '#eee';
                        }
                    }
                }
            }
        },

        filters: {
            formatDate: function (val) {
                if (val == null || val === undefined) {
                    return '';
                }
                return moment(val).format('YYYY-MM-DD');
            }
        }
    };
</script>
<style scoped>
.updateContent {
  height: 200px;
  overflow: auto;
}
.updateContent::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
ul {
  list-style: none;
}
/*header_Up*/
.ivu-layout-header {
  padding: 0 !important;
  height: auto !important;
  line-height: 50px;
}

/*头部*/
.header {
  width: 100%;
  min-width: 1200px;
}

.header > .header_Up {
  width: 100%;
  padding: 0 15px;
  height: 50px;
  margin: 0 auto;
  position: relative;
  background: #fff;
}
.header > .header_Up > .header_Up_Box {
  display: inline-block;
  width: 78%;
  height: 50px;
}
.header > .header_Up > .header_Up_Box .header_Up_img {
  display: inline-block;
  width: 20%;
  height: 50px;
}
.header > .header_Up > .header_Up_Box .header_Up_img > img {
  padding: 5px 0;
  display: block;
  width: auto;
  height: 100%;
}
.header_Up_ul {
  display: inline-block;
  width: 80%;
  float: right;
}

.header > .header_Up > .header_Up_Box > .header_Up_ul > ul {
  display: inline-block;
  display: flex;
  justify-content: space-left;
  width: 100%;
  height: 100%;
}

.header > .header_Up .header_Up_Box > .header_Up_ul > ul > li {
  width: 90px;
  text-align: center;
  position: relative;
  line-height: 50px;
  cursor: pointer;
  color: #494949;
}

.header > .header_Up > .header_Up_Box > .header_Up_ul ul > li:hover {
  color: #fd8900;
}
.header > .header_Up > .header_Up_Box > .header_Up_ul ul > li.cur:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -17.5px;
  width: 35px;
  height: 5px;
  background: #fd9e00;
}
/*有内容样式*/
.header_Down_Box {
  width: 100%;
  padding: 0 40px;
  height: 40px;
  background: #fd9e00;
}
.header_Down ul {
  height: 40px;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.header_Down ul li {
  margin: 0 10px;
  position: relative;
  color: #fff;
  padding: 0px 5px;
  line-height: 20px;
  cursor: pointer;
}

.header_Down ul li:hover {
  background: #fd9e00;
}

.header_Down ul li:hover .nav {
  display: block;
}
.header_Down ul li a {
  color: #fff;
  display: block;
  height: 40px;
  line-height: 40px;
}
.header_Down ul li .nav {
  /*display: block;*/
  min-width: 165px;
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: #fd9e00;
  z-index: 1000;
}

.header_Down ul li .nav dt {
  display: block;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
}
.header_Down ul li .nav dt a {
  color: #fff;
}
.header_Down ul li .nav dt:hover {
  background: #fd9e00;
}
.header_Down_Hind {
  display: none;
}
/*无内容样式*/
.header_Down_Border {
  height: 3px;
  width: 100%;
  background: #fd9e00;
}
.header .user {
  position: absolute;
  top: 0;
  left: 80%;
  width: 20%;
  height: 50px;
}
.user_Style {
  float: right;
}
.user_Style a {
  color: #494949;
}
.ivu-row {
  height: 50px;
}
.input_span span {
display: inline-block;
width: 85px;
height: 10px;
background: #eee;
line-height: 20px;
}

.one {
border-top-left-radius: 5px;
border-bottom-left-radius: 5px;
border-right: 0px solid;
margin-left: 20px;
margin-right: 3px;
}

.two {
border-left: 0px solid;
border-right: 0px solid;
margin-left: -5px;
margin-right: 3px;
}

.three {
border-top-right-radius: 5px;
border-bottom-right-radius: 5px;
border-left: 0px solid;
margin-left: -5px;
}
#font span:nth-child(1){
color:red;
margin-left: 80px;
}
#font span:nth-child(2){
    color:orange;
    margin: 0 60px;
  }
#font span:nth-child(3){
     color:#00D1B2;
  }
  p.UpdateContentClass > ul {
  margin-left: 20px !important;
}

.currentVersionNumberCss .ivu-tooltip-inner {
  max-width: 324px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue